import React from 'react';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';

export default function LandingCtaBanner({ onStart }) {
    return (
        <Card sx={{ borderRadius: 3, border: (theme) => `1px solid ${theme.palette.divider}` }}>
            <CardContent
                sx={{
                    py: { xs: 3, md: 4 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    flexDirection: { xs: 'column', md: 'row' },
                }}
            >
                <Box>
                    <Typography variant="h6" fontWeight={800}>
                        Bereit, dir Zeit &amp; Nerven zu sparen?
                    </Typography>
                    <Typography color="text.secondary">
                        Starte jetzt mit Schreiberlein Pro – wähle monatlich oder jährlich.
                    </Typography>
                </Box>
                <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
                    <Button
                        variant="contained"
                        onClick={onStart}
                        sx={{ bgcolor: 'orange', '&:hover': { bgcolor: '#cc7a00' }, borderRadius: 2 }}
                    >
                        Pro starten
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
}
